import { render } from "./ListSize.vue?vue&type=template&id=1bc06589&scoped=true"
import script from "./ListSize.vue?vue&type=script&lang=js"
export * from "./ListSize.vue?vue&type=script&lang=js"

import "./ListSize.vue?vue&type=style&index=0&id=1bc06589&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc06589"]])

export default __exports__